import { render, staticRenderFns } from "./TheLightbox.vue?vue&type=template&id=0bfff678&scoped=true&"
import script from "./TheLightbox.vue?vue&type=script&lang=js&"
export * from "./TheLightbox.vue?vue&type=script&lang=js&"
import style0 from "./TheLightbox.vue?vue&type=style&index=0&id=0bfff678&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfff678",
  null
  
)

export default component.exports